export default __webpack_public_path__ + "static/media/footer-facebook.de7cedee.svg";